const hasOwn = (value, key) =>
  value !== null &&
  typeof value === "object" &&
  Object.prototype.hasOwnProperty.call(value, key);

export const hasExplicitMarkValue = (criterion) =>
  hasOwn(criterion, "value") &&
  criterion.value !== null &&
  criterion.value !== undefined;

export const sectionHasMarks = (section) => {
  const criteria = Array.isArray(section?.checkboxes)
    ? section.checkboxes
    : [];
  return criteria.some(hasExplicitMarkValue);
};

export const stationHasMarks = (station) => {
  const sections = Array.isArray(station?.markSchemeSections)
    ? station.markSchemeSections
    : [];
  return sections.some(sectionHasMarks);
};

export const stationSummaryHasMarks = (summary) => {
  if (typeof summary?.hasMarks === "boolean") return summary.hasMarks;
  return typeof summary?.points === "number" && summary.points > 0;
};

export const sectionSummaryHasMarks = (summary) => {
  if (typeof summary?.hasMarks === "boolean") return summary.hasMarks;
  return (
    typeof summary?.percentage === "number" && summary.percentage > 0
  );
};

export const stationSummaryCountsAsComplete = (summary) =>
  stationSummaryHasMarks(summary) || summary?.completed === true;

export const hasRecordedScore = (scores, stationId) =>
  hasOwn(scores, stationId);
